import { render, staticRenderFns } from "./RemoveConfirmationModal.vue?vue&type=template&id=26889552&scoped=true&"
import script from "./RemoveConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./RemoveConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveConfirmationModal.vue?vue&type=style&index=0&id=26889552&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26889552",
  null
  
)

export default component.exports